export interface InfoProps {
  data: any
  title: string
  sectionIndex?: string
}

export const decodeFromDictionary = (
  dictionaries: Record<string, Record<string, string>>,
  key: string,
  value: string | number
) => {
  if (value === null || value === undefined || value === '') return '—'
  const dict = dictionaries[key]
  if (dict) {
    const mapped = dict[value.toString()]
    if (mapped) return mapped
  }
  return String(value)
}

export const formatScore = (value?: number) => {
  if (value === undefined || value === null || Number.isNaN(value)) return '—'
  return value.toFixed(2)
}

export const getRiskLevel = (value?: number) => {
  if (value === undefined || value === null || Number.isNaN(value)) return '未知'
  if (value >= 0.8) return '高风险'
  if (value >= 0.5) return '中风险'
  return '低风险'
}
